import React            from 'react'
import {useHistory}     from "react-router"
import {useTranslation} from "react-i18next"

import {IonIcon, IonItemOption, useIonAlert} from "@ionic/react"
import {trashOutline, trashSharp} from "ionicons/icons"

import {User as ItemType}     from "@customTypes/User"
import {useUsers as useItems} from "../../../contexts/UserContext"
import {useAuth}              from "../../../contexts/AuthContext"


interface componentProps {
    item: ItemType
}

const ListItemOptionDelete: React.FC<componentProps> = ({item}) => {
    const history = useHistory()
    const [presentAlert] = useIonAlert()
    const { t }          = useTranslation()

    const { deleteItem } = useItems()
    const { getMe }      = useAuth()


    const closeItemSliding = () => {
        document.querySelector('ion-item-sliding')?.closeOpened();
    }

    const alertDelete = async () => {
        return presentAlert({
            header:  t('users.alerts.delete.header'),
            message: t('users.alerts.delete.message'),
            buttons: [{
                text:    t('common.cancel'),
                role:    'cancel'
            }, {
                text:    t('common.delete'),
                role:    'confirm',
                handler: () => onDelete(),
            },],
        })

    }

    const onDelete = async () => {
        closeItemSliding()

        await deleteItem(item)
        await getMe()

        history.push('/users')
    }

    return (
        <IonItemOption color="danger" onClick={() => alertDelete()}>
            <IonIcon slot="top" ios={trashOutline} md={trashSharp} />
            {t('common.delete')}
        </IonItemOption>
    )
}

export default ListItemOptionDelete